/**
 * Modules that are planned but not built yet. Each gets a sidebar item and a
 * route rendering the shared "Coming soon" page, both gated on the
 * `upcomingModules` permission section (Super Admin and Admin only).
 *
 * Sidebar.tsx and App.tsx both read these lists, so a menu item and its route
 * can't drift apart. When a module gets built, take it out of here and give it
 * its own page and permission section.
 */
export interface UpcomingModule {
  path: string
  name: string
}

/** Business Modules group, after Jobs. */
export const UPCOMING_BUSINESS_MODULES: readonly UpcomingModule[] = [
  { path: '/business/calls', name: 'Calls' },
  { path: '/business/funds', name: 'Funds' },
  { path: '/business/tenders', name: 'Tenders' },
  { path: '/business/skills', name: 'Skills' },
  { path: '/business/directories', name: 'Directories' },
  { path: '/business/innovation', name: 'Innovation' },
]

/** Mini-Apps group, after Wallet, Creatives, Suppliers and OneMall. */
export const UPCOMING_MINI_APPS: readonly UpcomingModule[] = [
  { path: '/mini-apps/vuka', name: 'Vuka' },
  { path: '/mini-apps/foodie', name: 'Foodie' },
  { path: '/mini-apps/sparknotes', name: 'SparkNotes' },
  { path: '/mini-apps/events', name: 'Events' },
  { path: '/mini-apps/maps', name: 'Maps' },
  { path: '/mini-apps/triple-aaa', name: 'Triple AAA' },
  { path: '/mini-apps/kids', name: 'Kids' },
  { path: '/mini-apps/spaces', name: 'Spaces' },
]
